import { Separator } from "app/shadcnComponents/ui/separator";
import React, { useState } from "react";
import { getS } from "utils/helperFunctions";

interface Props {
  title: string;
  rows: {
    leftContent: JSX.Element | string;
    rightContent: JSX.Element | string;
  }[];
  expandedEntityName?: string;
}
const ConfirmationBox = ({
  title,
  rows,
  expandedEntityName,
}: Readonly<Props>) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const rowsShowing = isExpanded ? rows : rows.slice(0, 2);
  return (
    <div className="border rounded-sm p-4 shadow-sm bg-gray-50 flex flex-col gap-2">
      <h4 className="text-black">{title}</h4>

      {rowsShowing.map((row, index) => (
        <React.Fragment key={index}>
          <div className="flex justify-between">
            <div>{row.leftContent}</div>
            <div>{row.rightContent}</div>
          </div>
          {index !== rowsShowing.length - 1 && <Separator />}
        </React.Fragment>
      ))}
      {rows.length > 2 && (
        <>
          <Separator />
          <button onClick={() => setIsExpanded(!isExpanded)}>
            <p>
              {isExpanded
                ? "Show Less"
                : `+ ${rows.length - 2} more ${
                    expandedEntityName || "item"
                  }${getS(rows.length - 2)}`}
            </p>
          </button>
        </>
      )}
    </div>
  );
};

export default ConfirmationBox;
